const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheyresChables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.28mm",
    height: "49.69mm",
    viewBox: "0 0 41.28 49.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.265.266v40.48c7.037 3 14.39 6.132 20.37 8.684 6.693-2.805 14.17-5.92 20.37-8.684V.266H.255z",
    fill: "#f00000",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    style: {
      paintOrder: "markers fill stroke"
    },
    d: "M.265 15.48h40.75v12.48H.265z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.64 15.48h9.368v12.48h-1.76zM23.34 27.97l.47-12.48 7.609 12.48zM7.609 27.97.001 15.49h7.868l7.608 12.48z",
    style: {
      paintOrder: "fill markers stroke"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(.24 -.13) scale(.2646)",
    d: "M49.67 16.56c.631 5.641-.133 12 0 17.11 1.15 1.81 2.588 3.299 3.864 5.042v108.7c5.586.166 12.05.156 16.88 0 0-8.244-.179-17.04.141-24.22.568-3.883 4.244-6.966 8.164-5.718 3.304.913 5.375 3.764 5.103 7.132.147 7.186-.196 15.67 0 22.85h16.88v-108.7c1.342-1.752 2.573-3.36 3.863-5.042-.04-5.307 0-11.76 0-17.11h-10.97v9.31c-3.768 0-7.555-.06-10.99-.06v-9.31h-10.97v9.31c-3.613.163-7.654.032-10.99.014v-9.31c-3.437 0-7.861-.013-10.97 0z",
    fill: "#fff",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9 108a1.77 1.912 0 0 1 1.77-1.912A1.77 1.912 0 0 1 63.44 108m0 6.076v-6.111m-3.548 6.099v-6.111m3.548 6.124h4.467m-12.48-.012h4.467m3.225-32.17 2.909.016m-8.72-.012 2.909.016m5.811-2.467v2.463m-2.909-2.48v2.464m-2.902-2.463v2.463m-2.909-2.46V81.9m-2.902-2.463h2.902m8.72.012h2.902m-8.714-.016h2.902m4.789 34.65v-28.77l1.022-1.334V79.45m-13.5 34.62V85.3l-1.022-1.334V79.44",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    style: {
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-41.02 -75.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.01 109h2.881m-2.881 3.386h2.889m-2.079 0v1.681m-7.513-1.681h-2.889m2.079 0v1.681m.81-5.067h-2.89m8.86-3.386H67.9m-12.48 0h3.62m6.781 0V109m-8.321-3.386V109m2.154-6.773v2.907m4.012-2.907v2.907m0-6.293v-3.386m-4.011 3.386v-3.386m-4.234 3.386H67.9m-12.48-6.773H67.9m-6.24 10.16v-3.386m4.16 3.386v-3.386m-8.321 3.386v-3.386m-2.08 3.386H67.9m-6.24-6.773v-3.386m4.162 3.386v-3.386m-8.322 3.386v-3.386m-2.08 3.386H67.9m-6.24-6.773v-3.386m4.162 3.386v-3.386m-8.322 3.386v-3.386m-2.08 3.386H67.9m-12.48-3.386h12.49M54.4 83.962h14.52m-6.631 22.26.692-1.403m-1.946 1.403-.692-1.403m4.312 1.278-1.506.877m-4.49-.875 1.516.875m4.834 1.067H63.43m1.578 2.01H63.43m1.578 2.012H63.43m-3.548-4.022h-1.578m1.578 2.01h-1.578m1.578 2.012h-1.578m6.703 2.023v-6.777m-6.703 6.765v-6.777m0 .012c0-1.495 1.5-2.706 3.35-2.706s3.352 1.212 3.352 2.706",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    style: {
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-41.02 -75.23)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.23 87.22a.868 1.629 0 0 0-.868 1.628h.006v3.271h1.742v-3.386h-.014a.868 1.629 0 0 0-.865-1.513zM64.09 87.22a.868 1.629 0 0 1 .868 1.628h-.006v3.271H63.21v-3.386h.014a.868 1.629 0 0 1 .865-1.513z",
    style: {
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-41.02 -75.23)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.64 49.43 20.37-8.684v-.965M20.64 49.43.27 40.746v-.965m0-39.51h40.75m0 0v39.71M.27.271v39.51",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.529,
    style: {
      paintOrder: "markers fill stroke"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheyresChables);
export default __webpack_public_path__ + "static/media/cheyres-chables.9dbaca7f5092d4844c75d0b38c57a0fd.svg";
export { ForwardRef as ReactComponent };